<template>
  <div class="card">
    <div class="print">
      <div class="docdate">
        Indicatieve Berekening Gouden Handdruk {{ today }}
      </div>
      <img id="db-logo" src="../../../assets/db/DB-logo1.svg" />
      <table class="new">
        <tr>
          <th>
            De indicatieve {{ offerType == 2 ? 'uitkering' : 'looptijd' }} bij een netto
            voorbeeldrendement van {{ profile }}%
          </th>
        </tr>
        <tr>
          <td>
            U start met een kapitaal van <b>&euro; {{ formatPrice(amount, true) }},-</b>
          </td>
        </tr>
        <tr>
          <td v-if="offerType == 2">
            U wenst een uitkering te ontvangen met een looptijd van
            <b>{{ duration }} jaar</b>
          </td>
          <td v-if="offerType == 3">
            U wenst een uitkering te ontvangen van
            <b>&euro; {{ formatPrice(Number(target), true) }},- per jaar</b>
          </td>
        </tr>
        <tr>
          <td v-if="offerType == 2">
            Indicatieve bruto uitkering op startdatum is
            <b>&euro; {{ formatPrice(Number(charts.chart1[0][2]), true) }},-</b>
            per jaar {{ paymentSplit(Number(charts.chart1[0][2])) }}
          </td>
          <td v-if="offerType == 3">
            Indicatieve looptijd van <b>{{ formatPrice(Number(looptijd.huidigprofiel)) }}</b>
            jaar.
          </td>
        </tr>
      </table>

      <p class="msg">
        Uw GH-beleggingsrekening gaat van start nadat deze akkoord is bevonden en geopend, en uw
        getekende indicatieve berekening en het geld door ons is ontvangen. Wij houden op de
        uitkering van de GH-beleggingsrekening loonbelasting en inkomensafhankelijke zorgpremie
        in.
      </p>

      <h3>Hoe zeker bent u van deze {{ offerTypeText2 }}?</h3>
      <p>
        De bovenstaande {{ offerTypeText2 }} is niet gegarandeerd, niemand weet hoe uw
        beleggingen in de toekomst presteren. De rendementen kunnen mee-, maar ook tegenvallen.
        Daarom ziet u hierna ook wat u kunt verwachten bij meevallende ontwikkelingen (Goede Markt)
        {{ profile != 4 ?', bij een gemiddeld scenario (Gemiddelde markt)' : '' }}
        en als het behoorlijk tegenzit (Slechte markt).
      </p>

      <div class="graph" v-if="offerType == 2">
        <GChart
          :settings="{ packages: ['corechart'], language: 'nl-nl' }"
          :data="results5"
          :options="options1"
          type="ComboChart"
        />
      </div>

      <table :class="['new', paymentPeriod ? 'periode-' + paymentPeriod.replace(/\s/g, '') : '']">
        <tr>
          <th v-if="offerType == 2">
            Verwachte bruto uitkering {{ new Date().getFullYear() + Number(duration) }}
          </th>
          <th v-if="offerType == 3">
            Verwachte looptijd
          </th>
          <th v-if="offerType == 2">Per jaar</th>
          <th v-if="offerType == 3">Jaren</th>
        </tr>
        <tr>
          <td>{{ getCols()[1].label }}</td>
          <td>
            <strong v-if="offerType == 2">
              &euro; {{ formatPrice(charts.chart5[duration - 1][1], true) }},-
              {{ paymentSplit(charts.chart5[duration - 1][1]) }}
            </strong>
            <strong v-if="offerType == 3">
              {{formatPrice(Number(looptijd.slechtscenario))}}
            </strong>
          </td>
        </tr>
        <tr>
          <td>{{ getCols()[2].label }}</td>
          <td>
            <strong v-if="offerType == 2">
              &euro; {{ formatPrice(charts.chart5[duration - 1][2], true) }},-
              {{ paymentSplit(charts.chart5[duration - 1][2]) }}
            </strong>
            <strong v-if="offerType == 3">
              {{formatPrice(Number(looptijd.huidigprofiel))}}
            </strong>
          </td>
        </tr>
        <tr v-if="profile != 4">
          <td>{{ getCols()[4].label }}</td>
          <td>
            <strong v-if="offerType == 2">
              &euro; {{ formatPrice(charts.chart5[duration - 1][4], true) }},-
              {{ paymentSplit(charts.chart5[duration - 1][4]) }}
            </strong>
            <strong v-if="offerType == 3">
              {{formatPrice(Number(looptijd.gemiddeldscenario))}}
            </strong>
          </td>
        </tr>
        <tr>
          <td>{{ getCols()[3].label }}</td>
          <td>
            <strong v-if="offerType == 2">
              &euro; {{ formatPrice(charts.chart5[duration - 1][3], true) }},-
              {{ paymentSplit(charts.chart5[duration - 1][3]) }}
            </strong>
            <strong v-if="offerType == 3">
              {{formatPrice(Number(looptijd.goedscenario))}}
            </strong>
          </td>
        </tr>
      </table>

      <p class="msg">
        Let op! Deze bedragen zijn niet zeker. Uw werkelijke
        uitkering kan nog hoger of nog lager zijn. U moet voor uzelf nagaan of een lagere
        uitkering past bij uw uitgavenpatroon. Een adviseur kan u hierbij helpen. Neem hierover
        gerust contact met ons op via 020 555 0055.
      </p>
    </div>
    <div class="pagefooter">
      &copy; info@doelbeleggen.nl - 020 555 0055 - Dorpsstraat 34 - 1182 JE Amstelveen
    </div>
    <div class="pagenumber" />
    <div class="break" />
  </div>
</template>

<script>
import { cloneDeep } from 'lodash-es';

export default {
  props: {
    amount: {
      type: Number,
      required: true,
      default: 100,
    },
    duration: {
      type: Number,
      required: true,
      default: 10,
    },
    offerType: {
      type: Number,
      required: true,
      default: 1,
    },
    paymentPeriod: {
      type: String,
      required: true,
      default: 'Per maand',
    },
    charts: {
      type: Object,
      required: true,
    },
    profile: {
      type: Number,
      required: true,
    },
    target: {
      type: Number,
      required: true,
    },
    looptijd: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      today: new Date().toLocaleString('nl-NL').split(' ')[0].replace(/\//g, '-'),
      options1: {
        backgroundColor: { fill: 'transparent' },
        height: 250,
        legend: { position: 'top' },
        pointSize: 0,
        chartArea: {
          left: 65,
          top: 55,
          bottom: 30,
          right: 20,
          width: '100%',
          height: '100%',
        },
        hAxis: {
          format: 'short',
          textStyle: { fontSize: 13 },
          gridlines: { color: '#eee' },
        },
        vAxis: {
          gridlines: { color: '#eee' },
          textStyle: { fontSize: 13 },
        },
        series: {
          0: { type: 'line', color: '#c1272d' },
          1: { type: 'line', color: '#67bf00' },
          2: { type: 'line', color: '#000066' },
        },
      },
    };
  },
  computed: {
    offerTypeText() {
      if (this.offerType === 3) {
        return 'vaste uitkering';
      }
      // this.offerType === 2
      return 'vaste looptijd';
    },
    offerTypeText2() {
      if (this.offerType === 3) {
        return 'looptijd';
      }
      // this.offerType === 2
      return 'uitkering';
    },
    results5() {
      let chart = [this.getCols()].concat(this.charts.chart5);
      if (this.profile === 4 && this.charts.chart5[0].length > 4) {
        chart = cloneDeep(chart);
        chart.forEach((arr) => arr.pop());
      }
      return chart;
    },
    paymentTerms() {
      if (this.paymentPeriod === 'Per maand') {
        return 12;
      }
      if (this.paymentPeriod === 'Per kwartaal') {
        return 4;
      }
      if (this.paymentPeriod === 'Per halfjaar') {
        return 2;
      }
      return 1;
    },
  },
  methods: {
    getCols() {
      const cols = [];
      cols.push({
        type: 'string',
        label: 'Jaar',
      });
      cols.push({
        type: 'number',
        label: 'Slecht (-2%)',
      });
      cols.push({
        type: 'number',
        label: `Indicatie (${this.profile}%)`,
      });
      cols.push({
        type: 'number',
        label: 'Goed (6%)',
      });
      // voor oude charts
      if (this.charts.chart5[0].length > 4) {
        cols.push({
          type: 'number',
          label: 'Gemiddeld (4%)',
        });
      }
      return cols;
    },
    paymentSplit(amount) {
      let optional = '';
      if (this.paymentPeriod !== 'Per jaar') {
        optional = `(€ ${this.formatPrice(amount / this.paymentTerms, true)} per
        ${this.paymentPeriod})`;
      }
      return `${optional}`;
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "../../../scss/_paper.scss";
</style>
